module.exports = __webpack_public_path__ + "static/media/4-7.dc58159f.mp3";